import { useMutation } from "@apollo/client";

import { GqlClientCreateInput } from "~/__generated__";

import { ClientListScreen_GetAllDocument } from "../../ClientListScreen/queries.generated";
import { ClientCreateDocument } from "../mutations.generated";

export default function useClientCreate() {
    const [clientCreate, { data, loading, error }] = useMutation(ClientCreateDocument, {
        refetchQueries: [ClientListScreen_GetAllDocument],
    });

    return {
        clientCreate: (input: GqlClientCreateInput) =>
            clientCreate({
                variables: { input },
            }),
        loading,
        error,
        data: data?.clientCreate,
    };
}
